let state = {
    clear() {
        this.current_user = null;
        this.current_client = null;
        this.current_cart = null;
    },
    current_user: null,
    current_client: null,
    current_cart: null,
    show_message: false,
    message: "",
    message_color: "",
};
export default state;
